import type { InventoryItemPayload } from "../repositories/inventoryItem.repository";

interface BuildInventoryPayloadInput {
  data: Record<string, unknown>;
  terreiroId?: string;
  mediumId?: string;
}

export function buildInventoryCreatePayload({
  data,
  terreiroId,
  mediumId,
}: BuildInventoryPayloadInput): InventoryItemPayload | null {
  const owner =
    terreiroId && terreiroId.length > 0
      ? { terreiroId }
      : mediumId && mediumId.length > 0
      ? { mediumId }
      : null;

  if (!owner) return null;

  const quantityValue =
    typeof data.quantity === "number"
      ? data.quantity
      : Number(data.quantity || 0);
  const minimumQuantityValue =
    typeof data.minimumQuantity === "number"
      ? data.minimumQuantity
      : Number(data.minimumQuantity || data.minQuantity || 0);

  return {
    ...owner,
    name: String(data.name || ""),
    category: String(data.category || ""),
    description: String(data.description || ""),
    location: String(data.location || ""),
    quantity: Number.isFinite(quantityValue) ? Math.max(0, quantityValue) : 0,
    minQuantity: Number.isFinite(minimumQuantityValue)
      ? Math.max(0, minimumQuantityValue)
      : 0,
    unit: String(data.unit || "UNIDADE"),
    subcategory:
      typeof data.subcategory === "string" ? data.subcategory : undefined,
    imageUrl: typeof data.imageUrl === "string" ? data.imageUrl : undefined,
    consumable:
      typeof data.consumable === "boolean" ? data.consumable : undefined,
    estimatedUnitCost:
      typeof data.estimatedUnitCost === "number" &&
      Number.isFinite(data.estimatedUnitCost)
        ? data.estimatedUnitCost
        : undefined,
    file:
      data.file instanceof File ||
      (typeof data.file === "object" && data.file !== null)
        ? (data.file as File | Record<string, unknown>)
        : undefined,
  };
}
